export default "__VITE_ASSET__CbrRwJw3__"